import plzData from './plz.json';

interface PlzBereich {
  plz_prefix: string;        // 2-stellig
  preis_eur: number;
  bundesland: string;
  abholung_durch: string;
  krematorium: string;
}

interface PlzData {
  energie_zuschlag_eur: number;
  plz_bereiche: PlzBereich[];
}

const data = plzData as PlzData;

export interface AbholResult {
  anfahrbar: boolean;
  preis_eur?: number;     // nur wenn anfahrbar
  details?: PlzBereich;   // für Logging/interne Anzeige
}

/**
 * Prüft, ob eine PLZ angefahren werden kann, und liefert ggf. den Preis.
 * Endpreis = Bereich-Preis + Energie-Zuschlag (190 EUR, siehe plz.json).
 *
 * Akzeptiert 5-stellige PLZ als String. Matcht über die ersten 2 Stellen.
 */
export function pruefeAbholung(plz5: string): AbholResult {
  if (!/^\d{5}$/.test(plz5)) {
    return { anfahrbar: false };
  }
  const prefix = plz5.substring(0, 2);
  const treffer = data.plz_bereiche.find(b => b.plz_prefix === prefix);
  if (!treffer) {
    return { anfahrbar: false };
  }
  return {
    anfahrbar: true,
    preis_eur: treffer.preis_eur + data.energie_zuschlag_eur,
    details: treffer,
  };
}

export const ENERGIE_ZUSCHLAG_EUR = data.energie_zuschlag_eur;
